module.exports = __webpack_public_path__ + "img/tb314-1993.asm.bace3a95.jpg";